import { DropZone, ServiceList, HTTPRequest } from '@bimser/common';
import {
	BCButton,
	BCNotification,
	BCPopover,
	BCScrollbars,
	findMessage,
	ViewerType
} from '@bimser/components';
import { ILanguage, MLHelper, isNullOrUndefined } from '@bimser/core';
import IconNewFile from '@bimser/icons/16/add';
import IconInfo from '@bimser/icons/16/info';
import IconDMExplorer from '@bimser/icons/16/open';
import IconDownload from '@bimser/icons/16/download';
import IconCompare from '@bimser/icons/16/comparison';
import classNames from 'classnames/bind';
import dayjs from 'dayjs';
import * as React from 'react';
import ClassNames from '../../../../../assets/RDStyle.scss';
import { geti18nValue } from '../../../../../helper';
import {
	IRelatedDocumentCategory,
	IRelatedDocumentFile,
	IRelatedDocumentsOptions,
	RelatedDocumentAddingMode,
	RelatedDocumentsViewType
} from '../entities';
import { getAllowedExtensionsOptions } from '../helper/getAllowedExtensionsOptions';
import { createElementForDownloadAll } from '../helper/createElementForDownloadAll';

import RDFile from './RDFile';
import { RDButtonType, RDButtonTypeRef } from './RDButtonType';
const img = require('../../../../../assets/img/releated-documents-empty.svg');

const cx = classNames.bind(ClassNames);
class RDCategory extends React.PureComponent<IProps, any> {
	tempData: IRelatedDocumentFile[];
	rdButtonTypeRef: RDButtonTypeRef;

	constructor(props: IProps) {
		super(props);

		this.renderCategoryHeader = this.renderCategoryHeader.bind(this);
		this.renderFile = this.renderFile.bind(this);
		this.renderViewTypeButton = this.renderViewTypeButton.bind(this);
		this.onOptionsItemClicked = this.onOptionsItemClicked.bind(this);
		this.onDropFiles = this.onDropFiles.bind(this);
		this.onAddDM = this.onAddDM.bind(this);
		this.onAddEvent = this.onAddEvent.bind(this);
		this.onAddLocal = this.onAddLocal.bind(this);
		this.getContainerClassName = this.getContainerClassName.bind(this);
		this.onDownloadAll = this.onDownloadAll.bind(this);
		this.onAddDownloadClick = this.onAddDownloadClick.bind(this);
		this.renderCompareButton = this.renderCompareButton.bind(this);
		this.isFileComparable = this.isFileComparable.bind(this);

		this.state = {
			onDragOver: false,
			selectedFiles: [],
			viewerConfig: [],
			isCheckedForDownload: false
		};

		this.tempData = [
			{
				id: '10132',
				name: 'scroll.jpg',
				description: 'scroll',
				path: '/usr/%username%/files',
				extension: 'jpg',
				createDate: dayjs().toISOString(),
				creator: 'admin',
				creatorId: 1,
				data: '',
				key: 'test1',
				secretKey: 'test1',
				category: this.props.category
			},
			{
				id: '6316',
				name: 'hr.xls',
				description: 'hr',
				path: '/usr/%username%/files',
				extension: 'xls',
				createDate: dayjs().toISOString(),
				creator: 'admin',
				creatorId: 1,
				data: '',
				key: 'test2',
				secretKey: 'test2',
				category: this.props.category
			},
			{
				id: '5259',
				name: 'rest.png',
				description: 'exampleDescription',
				path: '/usr/%username%/files',
				extension: 'png',
				createDate: dayjs().toISOString(),
				creator: 'admin',
				creatorId: 1,
				data: '',
				key: 'test3',
				secretKey: 'test3',
				category: this.props.category
			},
			{
				id: '4394',
				name: 'create.docx',
				description: 'exampleDescription',
				path: '/usr/%username%/files',
				extension: 'docx',
				createDate: dayjs().toISOString(),
				creator: 'admin',
				creatorId: 1,
				data: '',
				key: 'test4',
				secretKey: 'test4',
				category: this.props.category
			},
			{
				id: '3903',
				name: 'Screenshot_1.png',
				description: 'exampleDescription',
				path: '/usr/%username%/files',
				extension: 'png',
				createDate: dayjs().toISOString(),
				creator: 'admin',
				creatorId: 1,
				data: '',
				key: 'test5',
				secretKey: 'test5',
				category: this.props.category
			}
		];
	}

	componentDidMount(): void {
		if (!this.props.options.disabled) {
			const getViewerOptions = async () => {
				const response =
					await ServiceList.dm.DocumentManagement.Explorer.GetParameters.callPromise(
						true
					);

				this.setState({
					viewerConfig: response.viewersConfig
				});
			};

			getViewerOptions();
		}
	}

	onAddEvent() {
		if (this.props.isPreviewMode) {
			BCNotification.warning({
				message: findMessage.get('101392')
			});
		} else if (this.props.onAddClick) {
			this.props.onAddClick(this.props.addingMode, this.props.category.categoryId);
		}
	}

	onAddLocal() {
		if (this.props.isPreviewMode) {
			BCNotification.warning({
				message: findMessage.get('101392')
			});
		} else if (
			this.props.onAddClick &&
			(this.props.addingMode === RelatedDocumentAddingMode.Local ||
				this.props.addingMode === RelatedDocumentAddingMode.All)
		) {
			this.props.onAddClick(RelatedDocumentAddingMode.Local, this.props.category.categoryId);
		}
	}

	onAddDM() {
		if (this.props.isPreviewMode) {
			BCNotification.warning({
				message: findMessage.get('101392')
			});
		} else if (
			this.props.onAddClick &&
			(this.props.addingMode === RelatedDocumentAddingMode.DM ||
				this.props.addingMode === RelatedDocumentAddingMode.All)
		) {
			this.props.onAddClick(RelatedDocumentAddingMode.DM, this.props.category.categoryId);
		}
	}

	async onDownloadAll() {
		if (this.props.isPreviewMode) {
			BCNotification.warning({
				message: findMessage.get('101392')
			});
		} else if (
			this.props.addingMode === RelatedDocumentAddingMode.DM ||
			this.props.addingMode === RelatedDocumentAddingMode.All
		) {
			if (!this.props.files.length) {
				return BCNotification.warning({
					message: findMessage.get('103118')
				});
			} else {
				try {
					const allFiles = this.props.files.map(item => ({
						secretKey: item.secretKey,
						fileName: item.name,
						versionSecretKey: '',
						path: item.path,
						addRecent: false
					}));
					const requestData = this.state.selectedFiles.length
						? this.state.selectedFiles
						: allFiles;
					const url =
						(window as any).serviceConfig.services.dm.baseURL +
						'/DocumentManagement/Objects/DownloadMulti';
					fetch(url, {
						body: JSON.stringify({ urlRequests: requestData }),
						method: 'POST',
						headers: {
							...HTTPRequest.defaultHeaders,
							'Content-Type': 'application/json'
						}
					})
						.then(response => response.blob())
						.then(blobData => {
							createElementForDownloadAll(
								blobData,
								`${MLHelper.getMLText(this.props.category.name)}.zip`
							);
						});
				} catch (error) {
					console.log(error);
				}
			}
		}
	}

	onOptionsItemClicked(fileId: string, eventKey: string) {
		if (this.props.isPreviewMode) {
			BCNotification.warning({
				message: findMessage.get('101392')
			});
		} else if (this.props.onFileListEventClick) {
			const afterEvent = () => {
				if (eventKey === 'compare') {
					const data = this.props.files.filter(item => item.id === fileId);

					this.props.onCompareFiles(data);
				} else if (eventKey === 'unlink') {
					if (this.state.selectedFiles?.find(item => item.id === fileId)) {
						this.setState({
							selectedFiles: this.state.selectedFiles.filter(
								file => file.id !== fileId
							)
						});
					}
				}
			};

			this.props.onFileListEventClick(fileId, eventKey, afterEvent);
		}
	}

	onDropFiles(files: File[], event: React.DragEvent) {
		if (
			this.props.addingMode === RelatedDocumentAddingMode.DM ||
			this.props.options.readOnly ||
			this.props.options.disabled
		) {
			return;
		}
		const selectionLimit = this.props.category.maxFilesCount
			? Math.max(this.props.category.maxFilesCount - this.props.files.length, 0)
			: null;
		let allowedFiles = files;
		let fileLength = files.length;

		if (
			this.props.category.allowedFileExtensions &&
			this.props.category.allowedFileExtensions.length > 0
		) {
			allowedFiles = files.filter(t =>
				this.props.category.allowedFileExtensions.includes(
					t.name.substr(t.name.lastIndexOf('.') + 1).toUpperCase()
				)
			);

			if (fileLength != allowedFiles.length) {
				BCNotification.warning({
					message: findMessage.get('101357')
				});
				fileLength = allowedFiles.length;
			}
		}

		if (this.props.category.maxFileSize && this.props.category.maxFileSize > 0) {
			allowedFiles = allowedFiles.filter(t => this.props.category.maxFileSize - t.size > 0);

			if (fileLength != allowedFiles.length) {
				BCNotification.warning({
					message: findMessage.get('101358')
				});
			}
		}

		if (selectionLimit && selectionLimit < allowedFiles.length) {
			BCNotification.warning({
				message: findMessage.get('101393')
			});
			return;
		}

		if (!(this.props.options.addNewEnabled && this.props.enabled)) {
			BCNotification.warning({
				message: findMessage.get('102771'),
				autoClose: 4000
			});
			return;
		}

		if (this.props.onFileDrop && allowedFiles.length > 0) {
			this.props.onFileDrop(allowedFiles, this.props.category.categoryId, true);
		}
	}

	renderAllowedExtensionPopoverMenuItems() {
		const allExtensions = getAllowedExtensionsOptions(
			this.props.category.allowedFileExtensions
		);

		const getText = (text: string, extensions: any) => {
			let fileExtension: string = null;
			extensions
				.filter((t: string) => this.props.category.allowedFileExtensions.includes(t))
				.forEach((item: string) => {
					if (isNullOrUndefined(fileExtension)) {
						fileExtension = item;
					} else {
						fileExtension += ', ' + item;
					}
				});

			return text + ' ( ' + fileExtension + ' )';
		};

		return allExtensions
			.filter(item =>
				item.extensions.find((t: string) =>
					this.props.category.allowedFileExtensions.includes(t)
				)
			)
			.map((item: any, i: number) => (
				<div
					key={i + '-RDExtension'}
					className={[ClassNames.AllowedExtensionPopoverMenuItem].join(' ')}
				>
					<item.icon title={item.text} />
					<span
						className={ClassNames.AllowedFileTypeName}
						title={item.title}
					>
						{getText(item.text, item.extensions)}
					</span>
				</div>
			));
	}

	isFileComparable(file: IRelatedDocumentFile) {
		const isComparableDocument = ['pdf', 'docx', 'xlsx', 'pptx', 'doc', 'xls', 'ppt'].includes(
			file.extension
		);

		const viewerType = this.state.viewerConfig?.find(c => c.mimeTypes.includes(file.mimeType))
			?.viewerType;

		return isComparableDocument || viewerType === ViewerType.TextViewer;
	}

	renderCompareButton() {
		if (this.state.selectedFiles.length) {
			const data: IRelatedDocumentFile[] = this.state.selectedFiles.map(item =>
				this.props.files.find(file => file.secretKey === item.secretKey)
			);
			let isComparable = false;
			const extensions: string[] = data.map(item => item.extension);
			const isSameExtension = extensions.every((item, _, items) => item === items[0]);

			if (isSameExtension) {
				isComparable =
					this.state.selectedFiles.length <= 2 &&
					this.state.selectedFiles.every(item => item.comparable);
			}

			const onCompare = () => {
				this.props.onCompareFiles(data);
			};

			return isComparable ? (
				<BCButton
					onClick={onCompare}
					icon={<IconCompare />}
					disabled={this.props.options.disabled || this.props.options.readOnly}
					type="text"
				/>
			) : (
				''
			);
		} else return '';
	}

	renderAddButtons() {
		if (!this.props.options.addNewEnabled || !this.props.enabled) {
			return undefined;
		}

		const isLimitReached = this.props.files.length == this.props.category.maxFilesCount;
		const SingleAddIcon =
			this.props.addingMode == RelatedDocumentAddingMode.DM ? IconDMExplorer : IconNewFile;

		switch (this.props.addingMode) {
			case RelatedDocumentAddingMode.All: {
				return (
					<>
						{this.renderCompareButton()}
						<BCButton
							icon={<IconDownload />}
							disabled={this.props.options.disabled || this.props.options.readOnly}
							onClick={this.onDownloadAll}
							title={
								this.state.selectedFiles.length
									? findMessage.get('103398')
									: findMessage.get('103489')
							}
							type="text"
						/>
						<BCButton
							icon={<IconNewFile />}
							disabled={
								isLimitReached ||
								this.props.options.disabled ||
								this.props.options.readOnly
							}
							onClick={this.onAddLocal}
							title={findMessage.get('101386')}
							type="text"
						/>
						<BCButton
							icon={<IconDMExplorer />}
							disabled={
								isLimitReached ||
								this.props.options.disabled ||
								this.props.options.readOnly
							}
							onClick={this.onAddDM}
							title={findMessage.get('101387')}
							type="text"
						/>
					</>
				);
			}
			default: {
				return (
					<BCButton
						icon={<SingleAddIcon />}
						disabled={
							isLimitReached ||
							this.props.options.disabled ||
							this.props.options.readOnly
						}
						onClick={this.onAddEvent}
						title={findMessage.get('101202')}
						type="text"
					/>
				);
			}
		}
	}

	renderCategoryHeader() {
		const categoryName = `${geti18nValue(
			this.props.category.name,
			this.props.currentLanguage
		)}`;
		const maxFileCount = `${this.props.files.length}/${
			this.props.category.maxFilesCount || '∞'
		}`;
		const minFileCount = this.props.category.minFilesCount
			? `min:${this.props.category.minFilesCount}`
			: null;
		const categoryDescription = this.props.options.showCategoryDescription
			? ` - ${geti18nValue(this.props.category.description, this.props.currentLanguage)}`
			: null;

		return (
			<div className={ClassNames.CategoryHeader}>
				<div className={ClassNames.CategoryTitleAndDescription}>
					<span
						className={ClassNames.Title}
						title={categoryName}
					>
						{categoryName}
					</span>
					<span className={ClassNames.MaxFileCount}>{maxFileCount}</span>
					{minFileCount ? (
						<span className={ClassNames.MinFileCount}>{minFileCount}</span>
					) : null}
					{categoryDescription ? (
						<span
							className={ClassNames.Description}
							title={categoryDescription}
						>
							{categoryDescription}
						</span>
					) : null}
				</div>
				{this.props.enabled && (
					<div className={ClassNames.HeaderDocumentsButtons}>
						{this.renderAddButtons()}
						{this.props.category.allowedFileExtensions &&
							this.props.category.allowedFileExtensions.length > 0 && (
								<BCPopover
									key="Popover"
									content={this.renderAllowedExtensionPopoverMenuItems()}
									title={findMessage.get('100598')}
									overlayClassName={ClassNames.AllowedExtensionPopoverMenu}
									placement="bottom"
									trigger="hover"
									getPopupContainer={triggerNode => triggerNode as any}
								>
									<BCButton
										type="text"
										icon={<IconInfo />}
										title={findMessage.get('100647')}
									/>
								</BCPopover>
							)}
					</div>
				)}
			</div>
		);
	}

	getContainerClassName() {
		switch (this.props.viewType) {
			case RelatedDocumentsViewType.List:
				return ClassNames.RelatedDocumentListFileContainer;
			case RelatedDocumentsViewType.Compact:
				return ClassNames.RelatedDocumentCompactFileContainer;
			case RelatedDocumentsViewType.Card:
			default:
				return ClassNames.RelatedDocumentCardFileContainer;
		}
	}

	onAddDownloadClick(file: IRelatedDocumentFile, val: boolean, comparable: boolean) {
		if (val) {
			this.setState({
				selectedFiles: [
					...this.state.selectedFiles,
					{
						id: file.id,
						secretKey: file.secretKey,
						fileName: file.name,
						versionSecretKey: '',
						path: file.path,
						addRecent: false,
						comparable
					}
				]
			});
		} else {
			this.setState({
				selectedFiles: this.state.selectedFiles.filter(x => x.secretKey !== file.secretKey)
			});
		}
	}

	renderFile(f: IRelatedDocumentFile) {
		return (
			<RDFile
				key={f.id}
				file={f}
				options={this.props.options}
				viewType={this.props.viewType}
				onFileOptionClicked={this.onOptionsItemClicked}
				onAddDownloadClick={this.onAddDownloadClick}
				isComparable={this.isFileComparable(f)}
			/>
		);
	}

	renderViewTypeButton() {
		return (
			<RDButtonType
				ref={ref => (this.rdButtonTypeRef = ref)}
				onOptionsItemClicked={this.props.onFileListEventClick}
				category={this.props.category}
				addingMode={this.props.addingMode}
				onFileAdd={this.props.onAddClick}
				disabled={!this.props.enabled}
				options={this.props.options}
				files={this.props.files}
			/>
		);
	}

	render() {
		if (this.props.viewType === RelatedDocumentsViewType.Button) {
			return this.renderViewTypeButton();
		}

		const isLimitReached = this.props.files.length == this.props.category.maxFilesCount;
		const selectionLimit = this.props.category.maxFilesCount
			? Math.max(this.props.category.maxFilesCount - this.props.files.length, 0)
			: null;

		return (
			<DropZone
				allowDrag={!this.props.isPreviewMode && !isLimitReached}
				allowDrop={
					(selectionLimit !== null ? selectionLimit > 0 : true) &&
					!this.props.options.readOnly &&
					!this.props.options.disabled
				}
				onFiles={this.onDropFiles}
			>
				{props => {
					const ghostClassNames = cx({
						RelatedDocumentCardFile: this.props.viewType == 'card',
						RelatedDocumentListFile: this.props.viewType == 'list',
						RelatedDocumentCompactFile: this.props.viewType == 'compact',
						Ghost: true,
						Over: props.over
					});
					return (
						<div
							className={cx({
								RelatedDocumentsCategory: true,
								DisabledCategory: !this.props.enabled
							})}
							{...props.events}
						>
							{this.renderCategoryHeader()}
							<div className={ClassNames.CategoryContent}>
								<BCScrollbars
									styles={
										this.props.viewType == RelatedDocumentsViewType.Compact
											? { maxHeight: '98px' }
											: undefined
									}
								>
									{this.props.files.length == 0 && !props.over ? (
										<div className={ClassNames.EmptyItem}>
											{this.props.viewType !==
												RelatedDocumentsViewType.Compact && (
												<img
													className={ClassNames.EmptyItemImg}
													src={img.default}
													draggable="false"
												/>
											)}
											<div className={ClassNames.EmptyItemText}>
												<span>{findMessage.get('100563')}</span>
												{this.props.options.addNewEnabled &&
													this.props.enabled && (
														<span>
															{findMessage
																.get('100589')
																.substring(
																	0,
																	findMessage
																		.get('100589')
																		.indexOf('$0')
																)}
															<span
																className={
																	ClassNames.HyperLink +
																	' ' +
																	(this.props.options.readOnly ||
																	this.props.options.disabled
																		? ClassNames.DisabledHyperLink
																		: '')
																}
																onClick={this.onAddLocal}
															>
																{findMessage.get('101135')}
															</span>
															{findMessage
																.get('100589')
																.substring(
																	findMessage
																		.get('100589')
																		.indexOf('$0') + 2,
																	findMessage
																		.get('100589')
																		.indexOf('$1')
																)}
															<span
																className={
																	ClassNames.HyperLink +
																	' ' +
																	(this.props.options.readOnly ||
																	this.props.options.disabled
																		? ClassNames.DisabledHyperLink
																		: '')
																}
																onClick={this.onAddDM}
															>
																DM
															</span>
															{findMessage
																.get('100589')
																.substring(
																	findMessage
																		.get('100589')
																		.indexOf('$1') + 2
																)}
														</span>
													)}
											</div>
										</div>
									) : null}
									{this.props.files.length != 0 ||
									props.over ||
									this.props.isPreviewMode ? (
										<div className={this.getContainerClassName()}>
											<div
												key="dropGhost"
												className={ghostClassNames}
											></div>
											{this.props.isPreviewMode
												? this.tempData.map(this.renderFile)
												: this.props.files.map(this.renderFile)}
										</div>
									) : null}
								</BCScrollbars>
							</div>
						</div>
					);
				}}
			</DropZone>
		);
	}
}

interface IProps {
	isPreviewMode: boolean;
	addingMode: RelatedDocumentAddingMode;
	category: IRelatedDocumentCategory;
	files: IRelatedDocumentFile[];
	options: IRelatedDocumentsOptions;
	currentLanguage: ILanguage;
	viewType: RelatedDocumentsViewType;
	enabled: boolean;
	onFileListEventClick: (fileId: string, eventKey: string, cb?: () => void) => void;
	onAddClick: (addKey: RelatedDocumentAddingMode, categoryId: string) => void;
	onFileDrop?: (files: File[], categoryId: string, isDrop?: boolean) => void;
	onDownloadAllClick?: (files: any) => void;
	onCompareFiles?: (data: IRelatedDocumentFile[]) => void;
}

export { IProps as RDCardCategoryProps };
export default RDCategory;
